export { default } from './react-native-map-link';
export * from './react-native-map-link';
